import { createSlice } from "@reduxjs/toolkit";

/**
 * warrantsSlice
 *
 * Holds the currently-selected warrant being viewed or edited inside
 * WarrantFullDetails and all its sub-forms.
 *
 * Shape mirrors warrantRoot.warrants[0] from the API.
 */
const initialState = {
  activeWarrant: null,        // the warrant object currently open in the detail view
  activeWarrantIndex: null,   // index inside bookings.warrants[] (null = new)
  isDeleting: false,
  isSaving: false,
};

const warrantsSlice = createSlice({
  name: "warrants",
  initialState,
  reducers: {
    // Set the full active warrant (on row click / add)
    setActiveWarrant(state, action) {
      state.activeWarrant = action.payload;
    },

    // Patch any top-level field(s) on the active warrant
    // e.g. dispatch(patchActiveWarrant({ warrantNumber: "12345", charge: "..." }))
    patchActiveWarrant(state, action) {
      if (!state.activeWarrant) state.activeWarrant = {};
      state.activeWarrant = { ...state.activeWarrant, ...action.payload };
    },

    // Patch a nested array field on the active warrant
    // e.g. dispatch(patchActiveWarrantArray({ key: "warrantStateInfo", value: [...] }))
    patchActiveWarrantArray(state, action) {
      const { key, value } = action.payload;
      if (!state.activeWarrant) state.activeWarrant = {};
      state.activeWarrant = { ...state.activeWarrant, [key]: value };
    },

    setActiveWarrantIndex(state, action) {
      state.activeWarrantIndex = action.payload;
    },

    clearActiveWarrant(state) {
      state.activeWarrant = null;
      state.activeWarrantIndex = null;
    },

    setIsDeleting(state, action) {
      state.isDeleting = action.payload;
    },

    setIsSaving(state, action) {
      state.isSaving = action.payload;
    },
  },
});

export const {
  setActiveWarrant,
  patchActiveWarrant,
  patchActiveWarrantArray,
  setActiveWarrantIndex,
  clearActiveWarrant,
  setIsDeleting,
  setIsSaving,
} = warrantsSlice.actions;

export default warrantsSlice.reducer;
